<template>
	<div class="header">
			  <div class="logo-box">
				  <img class="logo" src="https://cdn.huimiaokeji.com/hjweb/logo.png"/>
			  </div>
			  <div class="top-menu">
				<div v-if='curPage=="home"' class="top-menu-item menu-item-active">首页</div>
				<div v-else class="top-menu-item" @click="navTo('/', 'home')">首页</div>
				<div v-if='curPage=="platform"' class="top-menu-item menu-item-active">平台优势</div>
				<div v-else class="top-menu-item" @click="navTo('/platform')">平台优势</div>
				<div v-if='curPage=="product"' class="top-menu-item menu-item-active">产品优势</div>
				<div v-else class="top-menu-item" @click="navTo('/product')">产品优势</div>
				<div v-if='curPage=="cases"' class="top-menu-item menu-item-active">合作案例</div>
				<div v-else class="top-menu-item" @click="navTo('/cases')">合作案例</div>
			  </div>
			  <div class="login-box" @click="goUrl('https://admin.huimiaokeji.com')">
				  <div class="login-btn">
					  登录
				  </div>
			  </div>
	</div>
</template>

<script>
	export default {
		props:['curPage'],
		data() {
			return {
				// curPage:"",
			}
		},
		methods: {
			navTo(url, page) {
				this.curPage = page;
				this.$router.push({ path:url})
			},
			goUrl(url){
					   window.open(url);
			}
		}
	}
</script>

<style lang="less">
.header {
	  display: flex;
	   height: 80px;
	  .logo-box {
		  flex:1;
		  display: flex;
		  align-items: center;
		  .logo {
			margin-left: 40px;
			width: 205px;	
			height: 30px;
		  }
	  }
	  .top-menu{
		  flex:1;
			  font-size: 14px;
			  font-family: PingFangSC, PingFang SC;
			  font-weight: 400;
			  color: #333333;
			  line-height: 80px;
			  display: flex;
			  justify-content: space-between;
			  padding-left: 200px;
			  padding-right: 200px;
			  // padding-left: 60%;
			  .top-menu-item {
				  // margin-right: 38px;
				  cursor: pointer;
			  }
			  .menu-item-active {
				  cursor: default;
				  color: #0B00B5;
				  font-weight: bold;
			  }
	  }
	  .login-box {
		  flex:1;
		  cursor: pointer;
		  .login-btn {
			  width: 120px;
			  height: 80px;
			  background: #0B00B5;
			  font-family: PingFangSC, PingFang SC;
			  font-weight: bold;
			  font-size: 14px;
			  color: #FFFFFF;
			  line-height: 80px;
			  text-align: center;
			  font-style: normal;
			  float: right;
		  }
	  }
  }
</style>


// WEBPACK FOOTER //
// src/components/header-menu.vue